import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ProductRecommendationEntity } from '@product/const/v2';
import { StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs';
import { StateWithProductRecommendations } from '../store';
import { ProductRecommendationActions } from '../store/actions';
import { ProductRecommendationSelectors } from '../store/selectors';

@Injectable({ providedIn: 'root' })
export class ProductRecommendationService {
  private lastLoadedBaseStore: string | null = null;

  constructor(private store: Store<StateWithProductRecommendations>) {}

  loadProductRecommendation(baseStoreCode: string): void {
    if (this.lastLoadedBaseStore === baseStoreCode) {
      return;
    }

    this.lastLoadedBaseStore = baseStoreCode;
    this.store.dispatch(new ProductRecommendationActions.ProductRecommendationLoad(baseStoreCode));
  }

  getProductRecommendationState(): Observable<StateUtils.LoaderState<ProductRecommendationEntity[]>> {
    return this.store.select(ProductRecommendationSelectors.getProductRecommendationState);
  }

  getProductRecommendation(): Observable<ProductRecommendationEntity[]> {
    return this.store.select(ProductRecommendationSelectors.getProductRecommendationValue);
  }

  getProductRecommendationLoading(): Observable<boolean> {
    return this.store.select(ProductRecommendationSelectors.getProductRecommendationLoading);
  }

  getProductRecommendationError(): Observable<boolean> {
    return this.store.select(ProductRecommendationSelectors.getProductRecommendationError);
  }

  getProductRecommendationSuccess(): Observable<boolean> {
    return this.store.select(ProductRecommendationSelectors.getProductRecommendationSuccess);
  }
}
